import script from "./MsgH.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgH.vue?vue&type=script&setup=true&lang=js"

import "./MsgH.vue?vue&type=style&index=0&id=6303df1a&lang=less"

const __exports__ = script;

export default __exports__